import React, { useContext, createContext, useState } from "react";
import { Toolbar } from "./components/utilities/Toolbar.tsx";
import { UserInfo, blankUserInfo } from './types/UserInfo.ts';

export const RepToolContext = createContext<{
    numberOfActiveModals: number,
    setNumberOfActiveModals: (numberOfActiveModals: number) => void,
    appendControls: (component: JSX.Element | null, currentComponent?: string) => void,
    removeLastControls: () => void,
    clearControls: (component: JSX.Element, currentComponent: string) => void,
    profileInfo: UserInfo | null,
    setProfileInfo: (profileInfo: UserInfo) => void,
    controlFunctions: Array<{ key: React.Key, component: JSX.Element | null, currentComponent?: string }>
}>({
    numberOfActiveModals: 0,
    removeLastControls: () => { },
    clearControls: () => { },
    setNumberOfActiveModals: () => { },
    appendControls: () => { },
    controlFunctions: [],
    profileInfo: null,
    setProfileInfo: () => { }
});

export const useRepToolContext = () => useContext(RepToolContext);

export const RepToolProviderWrapper = ({ children }: {
    children: React.ReactNode
}) => {
    const [profileInfo, setProfileInfo] = useState<UserInfo>(blankUserInfo);
    const [numberOfActiveModals, setNumberOfActiveModals] = useState<number>(0);
    const [controlFunctions, setControlFunctions] = useState<Array<{ key: React.Key, component: JSX.Element | null, currentComponent?: string }>>([]);
    return (
        <RepToolContext.Provider value={{
            numberOfActiveModals,
            setNumberOfActiveModals,
            profileInfo,
            setProfileInfo,
            clearControls: (component: JSX.Element | null, currentComponent: string) => {
                if (component == null) return setControlFunctions([]);
                setControlFunctions([{ key: new Date().getTime(), component, currentComponent }]);
            },
            removeLastControls: () => {
                const currentStack = controlFunctions;
                if (controlFunctions.length > 1) {
                    currentStack.pop();
                    setControlFunctions(currentStack);
                } else {
                    setControlFunctions([]);
                }
            },
            appendControls: (component: JSX.Element | null, currentComponent?: string) => {
                const key = new Date().getTime();
                const currentStack = controlFunctions
                if (currentComponent == controlFunctions[controlFunctions.length - 1]?.currentComponent) {
                    // remove the last one
                    currentStack.pop();
                }
                setControlFunctions([...currentStack, { key, component, currentComponent }]);
            },
            controlFunctions
        }}>
            {children}
            <Toolbar currentComponent={controlFunctions[controlFunctions.length - 1]?.component} />
        </RepToolContext.Provider>
    )
}